var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"color-picker-container"},[_c('input',{staticClass:"color-picker",attrs:{"type":"color"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('color-changed', { colorName: _vm.colorName, value: $event.target.value })}}}),_vm._v(" "),_c('span',{staticClass:"label-text"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }